import React from "react";
import { object, bool, string } from "prop-types";
import { Link } from "@quintype/components";
import { PublishAndReadTime } from "../../atoms/PublishAndReadTime";
import { HeroImage } from "../../atoms/HeroImage";
import { Label } from "../../atoms/Label";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../utils/story";
import Headline from "../../atoms/Headline";
import SubHeadline from "../../atoms/SubHeadline";

import "./three-col-twelve-or-eighteen-stories.m.css";

export const HeroStory = ({
  story,
  showSubheadline,
  showReadTime,
  showTimestamp,
  showSeparator,
  showPadding = true,
  sectionSlug,
}) => {
  const headline = getStoryHeadline(story);
  const label = getStoryLabel(story);
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl || `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <div
      styleName="hero-story"
      style={{ borderBottom: `${showSeparator || "none"}`, paddingBottom: `${showPadding || 0}` }}
    >
      <Link href={href} target={target}>
        <div styleName="main-story">
          <HeroImage story={story} aspectRatio={[[4, 3]]} iconSizes={{ height: 48, width: 48 }} />
          {label && <Label story={story} />}

          {headline && <Headline styleName="Hero-story-headline" headline={headline} sectionSlug={sectionSlug} />}
          {showSubheadline && story?.subheadline && (
            <SubHeadline styleName="subheadline" subHeadline={story?.subheadline} sectionSlug={sectionSlug} />
          )}
          <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimestamp} />
        </div>
      </Link>
    </div>
  );
};

HeroStory.propTypes = {
  story: object,
  showSubheadline: bool,
  showReadTime: bool,
  showTimestamp: bool,
  showSeparator: bool,
  showPadding: bool,
  sectionSlug: string,
};
